import { Button } from '@talentmesh/ui/components/button';
import { ButtonGroup } from '@talentmesh/ui/components/button-group';
import { cn } from '@talentmesh/ui/lib/utils';
import { useFormContext, useWatch } from 'react-hook-form';
import InformationOptionLabel from './InformationOptionLabel';
import UIStrings from '@/Utils/UIStrings';

interface InfoChoiceSelectorProps {
    label: string;
    name: string;
}

const InfoChoiceSelector = ({ label, name }: InfoChoiceSelectorProps) => {
    const { setValue } = useFormContext();
    const value = useWatch({ name });
    const mandatory = Boolean(value);

    return (
        <div className="flex flex-row flex-wrap items-center justify-between gap-4 px-10 py-4">
            <InformationOptionLabel label={label} />
            <ButtonGroup>
                <Button
                    type="button"
                    size="sm"
                    variant={mandatory ? 'default' : 'outline'}
                    className={cn('min-w-24 px-4')}
                    onClick={() => setValue(name, true)}
                >
                    {UIStrings.Mandatory}
                </Button>
                <Button
                    type="button"
                    size="sm"
                    variant={!mandatory ? 'default' : 'outline'}
                    className={cn('min-w-24 px-4')}
                    onClick={() => setValue(name, false)}
                >
                    {UIStrings.Off}
                </Button>
            </ButtonGroup>
        </div>
    );
};

export default InfoChoiceSelector;
